import { combineLatest, map, Observable, of, switchMap } from 'rxjs';
import { Injectable } from '@angular/core';
import { ActionButton } from '../models/action-button';
import { isEmptyArray, isNil, Nillable } from '@web/utils';

@Injectable({
  providedIn: 'root',
})
export class OnlyVisibleActionButtonsService<Action> {
  public resolveVisibility(
    actions: Nillable<ActionButton<Action>[]>,
  ): Nillable<Observable<ActionButton<Action>[]>> {
    if (isNil(actions)) {
      return of([]);
    }

    if (isEmptyArray(actions)) {
      return of([]);
    }

    return combineLatest(
      actions.map((action) =>
        action.visibility$().pipe(
          switchMap((visible) => {
            if (!visible) {
              return of(null);
            }

            return of(action);
          }),
        ),
      ),
    ).pipe(
      map((actions: Nillable<ActionButton<Action>>[]) =>
        actions.filter(
          (
            action: Nillable<ActionButton<Action>>,
          ): action is ActionButton<Action> => !isNil(action),
        ),
      ),
    );
  }
}
